import React from 'react';
import {IChangeDateGetAction} from "../../../../../../app/interfaces/shipment/IChangeDateGetAction";
import {FormikHelpers, useFormik} from "formik";
import {
    IChangeDatePostAction
} from "../../../../../../app/interfaces/shipment/IChangeDatePostAction";
import {useTranslation} from 'react-i18next';
import {Tooltip} from "react-tooltip";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircleInfo} from "@fortawesome/free-solid-svg-icons";
import cl from './ChangePlannedDateForm.module.css';
import {getStopPointIcon, getStopPointTypeResource} from "../../../../../../helpers/shipment";
import Textarea from "../../../../../../components/ui/Textarea/Textarea";
import moment from "moment";
import {IError} from "../../../../../../app/interfaces/response/IResponse";
import {BLErrorCode} from "../../../../../../app/enums/BLErrorCode";
import ReactDatePicker from "../../../../../../components/ui/ReactDatePicker/ReactDatePicker/ReactDatePicker";

type ChangePlannedDateFormProps = {
    model: IChangeDateGetAction;
    disabled: boolean;
    save: (model: IChangeDatePostAction) => Promise<void>;
    errors: Array<IError>;
}
const ChangePlannedDateForm: React.FC<ChangePlannedDateFormProps> = ({
                                                                         model,
                                                                         save,
                                                                         disabled,
                                                                         errors
                                                                     }) => {
    const {t} = useTranslation();

    const form = useFormik<IChangeDatePostAction>({
        initialValues: {
            orderReleaseGid: model.orderReleaseGid,
            dtItems: [],
            items: model.dtItems.map(item => {
                return {
                    ...item
                };
            })
        },
        onSubmit: async (values: IChangeDatePostAction, actions: FormikHelpers<IChangeDatePostAction>) => {
            actions.setSubmitting(true);

            values.dtItems = [];
            values.items.forEach(item => {
                values.dtItems.push({
                    position: item.position,
                    changeDateStart: item.changeDateStart,
                    reason: item.reason
                });
            });

            await save(values);

            actions.setSubmitting(false);
        }
    });

    return (
        <form id='change-date-form'
              onSubmit={form.handleSubmit}>
            <div className={'pd-10'}>
                <div className={cl.spList}>
                    {form.values.items.map((sp, index) => {
                        let icon = getStopPointIcon(sp.spType ?? '');

                        if (icon === null) {
                            return null;
                        }

                        let errs: Array<string> = [];

                        errors.filter(e => e.description !== null && Number(e.description) === sp.position)
                            .forEach(err => {
                                switch (err.errorCode) {
                                    case BLErrorCode.InvalidDate:
                                        errs.push(t("shipment.errors.change-date-incorrect-date"));
                                        break;
                                }
                            });

                        return (
                            <div key={sp.position} className={'mg-10'}>
                                <div className={cl.spLabel}>
                                    <FontAwesomeIcon icon={icon}
                                                     className={cl.icon}
                                                     data-sp-type={sp.spType}/>
                                    <label className={'view-label'}>
                                        {`${t(getStopPointTypeResource(sp.spType ?? ''))} ${sp.spInfo}`}
                                    </label>
                                </div>
                                <div className={`${cl.address} mgb-10`}>
                                    {sp.address}
                                </div>

                                <div className={`mgb-10`} style={{width: '50%'}}>
                                    <div className={cl.datePickerContainer}>
                                        <div style={{width: 'calc(100% - 16px)'}}>
                                            <ReactDatePicker disabled={disabled || sp.isLocked}
                                                             format={'dd.MM.yyyy HH:mm'}
                                                             size={'big'}
                                                             placeholder={t("shared.labels.date")}
                                                             value={sp.changeDateStart ? moment(sp.changeDateStart, 'DD.MM.YYYY HH:mm').toDate() : null}
                                                             onChange={(val) => {
                                                                 form.setFieldValue(`items[${index}].changeDateStart`, val ? moment(val).format('DD.MM.YYYY HH:mm') : null);
                                                             }}
                                            />
                                        </div>

                                        {sp.isLocked && sp.lockNote && sp.lockNote !== ''
                                            ? <div>
                                                <Tooltip id={`date-start-${sp.position}-${index}`}
                                                         style={{
                                                             maxWidth: '250px',
                                                             zIndex: '1002',
                                                             fontSize: '11px'
                                                         }}
                                                         place={'right'}/>
                                                <FontAwesomeIcon
                                                    data-tooltip-id={`date-start-${sp.position}-${index}`}
                                                    data-tooltip-content={t(`shipment.warnings.change-date-${sp.lockNote.toLowerCase()}`)}
                                                    icon={faCircleInfo}
                                                    className={cl.tooltipwarn}/>
                                            </div>
                                            : null
                                        }
                                    </div>

                                    {errs.length > 0 && errs.map(e => {
                                        return (
                                            <div className={'error-label'} key={e}>
                                                {e}
                                            </div>
                                        );
                                    })}
                                </div>

                                {model.showReasonFields &&
                                    <div>
                                        <Textarea disabled={disabled}
                                                  style={{
                                                      minHeight: '40px',
                                                      resize: 'vertical',
                                                      maxHeight: '150px'
                                                  }}
                                                  value={sp.reason ?? ''}
                                                  placeholder={t("shipment.form.change-date-reason-code")}
                                                  onChange={(ev: React.ChangeEvent<HTMLTextAreaElement>) => {
                                                      form.setFieldValue(`items[${index}].reason`, ev.target.value);
                                                  }}/>
                                    </div>
                                }
                            </div>
                        );
                    })}
                </div>
            </div>
        </form>
    )
        ;
};

export default ChangePlannedDateForm;
